import produce from 'immer';
import { ActionTypes } from '../actions/checkout';

export const initialState = {
    contactInfo: {
        email: '',
        errorMessage: '',
        firstName: '',
        isError: false,
        isLoading: false,
        lastName: '',
        phone: '',
        secondaryPhone: '',
        sendSms: true,
        termsConfirmed: false,
    },
    order: {
        data: null,
        detail: null,
        errorMessage: '',
        isError: false,
        isLoading: false,
    },
    position: 0,
    userId: null,
};

/* eslint-disable no-param-reassign */
function appCheckoutReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case ActionTypes.CHANGE_ORDER:
                draft.order.data = action.order;
                return draft;
            case ActionTypes.CHANGE_ORDER_DETAIL:
                draft.order.detail = action.order;
                return draft;
            case ActionTypes.CHANGE_ORDER_IS_LOADING:
                draft.order.isLoading = action.isLoading;
                return draft;
            case ActionTypes.CHANGE_ORDER_IS_ERROR:
                draft.order.isError = action.isError;
                return draft;
            case ActionTypes.CHANGE_ORDER_ERROR_MESSAGE:
                draft.order.errorMessage = action.errorMessage;
                return draft;
            case ActionTypes.CHANGE_USER_ID:
                draft.userId = action.userId;
                return draft;
            case ActionTypes.CHANGE_POSITION:
                draft.position = action.position;
                return draft;
            case ActionTypes.CHANGE_CONTACT_INFO_IS_LOADING:
                draft.contactInfo.isLoading = action.isLoading;
                return draft;
            case ActionTypes.CHANGE_CONTACT_INFO_IS_ERROR:
                draft.contactInfo.isError = action.isError;
                return draft;
            case ActionTypes.CHANGE_CONTACT_INFO_ERROR_MESSAGE:
                draft.contactInfo.errorMessage = action.errorMessage;
                return draft;
            case ActionTypes.CHANGE_CONTACT_INFO:
                draft.contactInfo.firstName = action.firstName;
                draft.contactInfo.lastName = action.lastName;
                draft.contactInfo.email = action.email;
                draft.contactInfo.phone = action.phone;
                draft.contactInfo.secondaryPhone = action.secondaryPhone;
                return draft;
            case ActionTypes.CHANGE_CONTACT_INFO_FIRST_NAME:
                draft.contactInfo.firstName = action.firstName;
                return draft;
            case ActionTypes.CHANGE_CONTACT_INFO_LAST_NAME:
                draft.contactInfo.lastName = action.lastName;
                return draft;
            case ActionTypes.CHANGE_CONTACT_INFO_EMAIL:
                draft.contactInfo.email = action.email;
                return draft;
            case ActionTypes.CHANGE_CONTACT_INFO_PHONE:
                draft.contactInfo.phone = action.phone;
                return draft;
            case ActionTypes.CHANGE_CONTACT_INFO_SECONDARY_PHONE:
                draft.contactInfo.secondaryPhone = action.secondaryPhone;
                return draft;
            case ActionTypes.CHANGE_CONTACT_INFO_SEND_SMS:
                draft.contactInfo.sendSms = action.sendSms;
                return draft;
            case ActionTypes.CHANGE_CONTACT_INFO_TERMS_CONFIRMED:
                draft.contactInfo.termsConfirmed = action.termsConfirmed;
                return draft;
            default:
                return draft;
        }
    });
}

export default appCheckoutReducer;
